export const capitalizeWord = (str) =>
  str[0][0].toUpperCase() + str[0].slice(1);

export const makeSingular = (word) => word.replace(/s$/, "");
export const makePlural = (word) => makeSingular(word) + "s";
export const joinWithLast = (arr, joinText, lastJoinText) => {
  if (arr.length <= 1) {
    return arr.join(joinText);
  }

  const copy = [...arr];
  const last = copy.splice(-1);

  return copy.join(joinText) + lastJoinText + last[0];
};
export const modifyStrWithCondition = (
  string,
  condition,
  { prefix = "", suffix = "" }
) => {
  return `${ifStr(prefix, condition)}${string}${ifStr(suffix, condition)}`;
};
export const ifStr = (str, condition, fallback = "") => {
  return condition ? str : fallback;
};

export const parseLinkText = (text, { linkClassName } = {}) => {
  const urlRegex =
    /((https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?)/gi;

  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[0];
    const index = match.index;

    if (index > lastIndex) {
      parts.push(text.substring(lastIndex, index));
    }

    const href = url.startsWith('http') ? url : `http://${url}`;
    parts.push(
      <a className={linkClassName} key={index} href={href} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );

    lastIndex = index + url.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
}